/*
 *   File : left-navigation.js
 *   Author : https://evoqins.com
 *   Description : Left navigation component
 *   Integrations : NA
 *   Version : 1.0.0
*/


import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

//Custom style
import styles from "../../Style/Component/left.module.scss";

//Custom component
import { Icon } from '../Icon';
import { _isOcrEnabled } from '../../Helper/country';

const LEFT_ITEMS = [
    {
        image_active: "home-inactive-icon",
        image_inactive: "home-icon",
        label: "Overview",
        path: "/",
        child_path: [],
    },
    {
        image_active: "admin-inactive-icon",
        image_inactive: "admin-icon",
        label: "Country Admins",
        path: "/country-admin",
        child_path: ["/country-admin"],
    },
    {
        image_active: "resource-active",
        image_inactive: "resource",
        label: "Manage Training",
        path: "/manage-training",
        child_path: ["/manage-training"],
    },
    {
        image_active: "news-active",
        image_inactive: "news",
        label: "Manage News",
        path: "/manage-news",
        child_path: [],
    },
    {
        image_active: "manage-store-active",
        image_inactive: "manage-store",
        label: "Manage Stores",
        path: "/manage-store",
        child_path: ["/manage-store"],
    },
];

const LEFT_ITEMS_COUNTRY = [
    {
        image_active: "home-inactive-icon",
        image_inactive: "home-icon",
        label: "Overview",
        path: "/",
        child_path: ["/top-selling", "/product-detail", "/product-detail/sales-breakdown"],
    },
    {
        image_active: "sales-specialist-active",
        image_inactive: "sales-specialist",
        label: "Sales Specialists",
        path: "/sales-specialist",
        child_path: ["/sales-specialist"],

    },
    {
        image_active: "new-request-active",
        image_inactive: "new-request",
        label: "Manage Requests",
        path: "/manage-request",
        child_path: ["/manage-request", "/request-history"],
    },
    {
        image_active: "store-detail-active",
        image_inactive: "store-detail",
        label: "All Stores",
        path: "/store-listing",
        child_path: ["/store-listing"],
    },
    {
        image_active: "manage-product-active",
        image_inactive: "manage-product",
        label: "Manage Products",
        path: "/manage-product",
        child_path: [],
    },
    {
        image_active: "catelog-active",
        image_inactive: "catelog",
        label: "Manage catalog",
        path: "/catalog",
        child_path: ["catalog"],
    },
    {
        image_active: "manage-ocr-active",
        image_inactive: "manage-ocr",
        label: "Manage sales invoices",
        path: "/invoices",
        child_path: ["/invoices"],
    },
    {
        image_active: "resource-active",
        image_inactive: "resource",
        label: "Manage training",
        path: "/manage-training",
        child_path: ["/manage-training"],
    },
    // {
    //     image_active: "reward-active",
    //     image_inactive: "reward",
    //     label: "Manage reward points",
    //     path: "/reward-points",
    //     child_path: [],
    // },
    {
        image_active: "reward-list-active",
        image_inactive: "reward-list-inactive",
        label: "Rewards",
        path: "/rewards",
        child_path: ["rewards"],
    },
    {
        image_active: "redeem-active",
        image_inactive: "redeem",
        label: "Manage redeem offers",
        path: "/redeem-offer",
        child_path: ["/redemption-history"],
    },
    {
        image_active: "notification-active",
        image_inactive: "notification",
        label: "Manage notification",
        path: "/manage-notification",
        child_path: [],
    },

    {
        image_active: "competition-active",
        image_inactive: "competition",
        label: "Manage Campaigns",
        path: "/campaign",
        child_path: ["/campaign"],
    },
    {
        image_active: "news-active",
        image_inactive: "news",
        label: "Manage News",
        path: "/manage-news",
        child_path: [],
    },
    {
        image_active: "banner-active",
        image_inactive: "banner",
        label: "Manage banners",
        path: "/banner-list",
        child_path: [],
    },
    {
        image_active: "fraud-active",
        image_inactive: "fraud-inactive",
        label: "Manage Fraud",
        path: "/manage-fraud",
        child_path: ["/manage-fraud"],
    }
];

const LeftNavigationWidget = (props) => {


    const navigate = useNavigate();
    const location = useLocation();

    const [hover, setHover] = useState(null);

    const [leftItemsCountryAdmin, setLeftItemsCountryAdmin] = useState([]);

    useEffect(() => {

        if (!props.profileData) return;

        // let updated = LEFT_ITEMS_COUNTRY.filter(item => item.path !== "/invoices");
        // let updated = LEFT_ITEMS_COUNTRY.filter(item => item.path !== "/invoices" && item.path !== "/rewards");
        let updated = LEFT_ITEMS_COUNTRY.filter(item => item.path !== "/invoices");

        let non_egypt_country = LEFT_ITEMS_COUNTRY.filter(item => item.path !== "/redeem-offer");

        if (_isOcrEnabled(props.profileData, props.ocrCountries)) {
            setLeftItemsCountryAdmin(non_egypt_country);
        } else {
            setLeftItemsCountryAdmin(updated);
        }

    }, [props.profileData, props.ocrCountries]);


    // handle tab 
    const _handleTabChange = (data) => {
        navigate(data.path);

        if (props.type === "offcanvas") {
            props.handleCloseOffCanvas();
        }
    }

    return (
        <div className='e-bg-white position-sticky top-0 left-0 min-vh-100 pt-5 transition'>
            {/* <p className='mb-0 text-end pt-3 '>
                {props.token === 'super_admin' ?
                    <span className="e-bg-azureish-white cursor-pointer px-2 py-1 e-border-radius-2px-0-0-2px e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-16px e-text-black">
                        Super admin
                    </span>
                    :
                    <span className="e-bg-carrara-white cursor-pointer px-2 py-1 e-border-radius-2px-0-0-2px e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-16px e-text-black">
                        Country admin
                    </span>
                }
            </p>
            <div className='text-center padding-14px-top mb-4 pb-3'>
                <img src={require("../../Assets/Image/LeftNavigation/jotun.svg").default}
                    draggable={false}
                    className={`${props.toggle === false ? 'w-70px' : ''} cursor-pointer e-jotun-logo transition`}
                    alt='logo'
                    onClick={() => {
                        navigate("/")
                        if (props.type === "offcanvas") {
                            props.handleCloseOffCanvas();
                        }
                    }} />
            </div> */}
            <div className={`e-left-nav-scroll d-flex flex-column gap-3 pe-2 ps-3 transition max-h-zoom-100vh overflow-scroll ${styles.e_left_nav_scroll} ${!props.toggle && 'text-center'} overscroll-behavior-none `}>
                {props.token === 'super_admin' ?
                    <>
                        {/* Navigation list for super admin */}
                        {LEFT_ITEMS.map((data, key) => (
                            <div key={key}>
                                {props.toggle === false ?
                                    <div className='d-flex justify-content-center'>
                                        <div className={`${data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) ?
                                            `${styles.e_tab_active_toggle}` : `${styles.e_tab_toggle} `} text-center transition padding-12px-tb px-3 cursor-pointer e-border-radius-8 `}
                                            onClick={() => _handleTabChange(data)}
                                            onMouseOver={() => setHover(data.path)}
                                            onMouseLeave={() => setHover(null)}>
                                            <Icon icon={data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) || hover === data.path ?
                                                data.image_active : data.image_inactive}
                                                className='d-flex'
                                                size="20px"
                                            />
                                        </div>
                                    </div>
                                    :
                                    <div className={`${data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) ?
                                        `${styles.e_tab_active}` : `${styles.e_tab} `} transition cursor-pointer e-display-flex gap-0-8 e-border-radius-8 padding-12px-lr py-2`}
                                        onClick={() => _handleTabChange(data)}
                                        onMouseOver={() => setHover(data.path)}
                                        onMouseLeave={() => setHover(null)} >
                                        <Icon icon={data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) || hover === data.path ?
                                            data.image_active : data.image_inactive}
                                            className='d-flex'
                                            size="17px" />

                                        <p className='transition e-text-rich-black-light mb-0 e-alt-font-noto-sans e-font-16 e-font-weight-400 line-height-20px text-capitalize'>
                                            {data.label}
                                        </p>
                                    </div>
                                }
                            </div>
                        ))}
                    </>
                    :
                    <>
                        {/* Navigation list for country admin */}
                        {leftItemsCountryAdmin.map((data, key) => (
                            <div key={key} className={`${data.path === location.pathname ? "pe-none" : ""}`}>
                                {props.toggle === false ?
                                    <div className='d-flex justify-content-center'>
                                        <div className={`${data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) ?
                                            `${styles.e_tab_active_toggle}` : `${styles.e_tab_toggle} `} text-center transition padding-12px-tb px-3 cursor-pointer e-border-radius-8 `}
                                            onClick={() => _handleTabChange(data)}
                                            onMouseOver={() => setHover(data.path)}
                                            onMouseLeave={() => setHover(null)}>
                                            <Icon icon={data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) || hover === data.path ?
                                                data.image_active : data.image_inactive}
                                                className='d-flex'
                                                size="20px"
                                            />
                                        </div>
                                    </div>
                                    :
                                    <div className={`${data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) ?
                                        `${styles.e_tab_active}` : `${styles.e_tab} `} transition cursor-pointer d-flex align-items-center gap-0-8 e-border-radius-8 py-2 px-2 `}
                                        onClick={() => _handleTabChange(data)}
                                        onMouseOver={() => setHover(data.path)}
                                        onMouseLeave={() => setHover(null)} >

                                        <Icon icon={data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) || hover === data.path ?
                                            data.image_active : data.image_inactive}
                                            className='d-flex'
                                            size="17px" />
                                        <p className='transition e-text-rich-black-light mb-0 e-alt-font-noto-sans e-font-16 e-font-weight-400 line-height-20px w-max-content text-capitalize'>
                                            {data.label}
                                        </p>

                                    </div>

                                }
                            </div>
                        ))}
                    </>
                }
            </div>
        </div>
    )
}

export default LeftNavigationWidget;